import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const BTN = 'inline-flex h-8 items-center gap-1 rounded-lg border border-border bg-background px-3 text-sm text-foreground transition-colors duration-150 hover:bg-secondary disabled:opacity-40';

export function TagPagination({ page, pageCount, total, pageSize, onPage }) {
  if (pageCount <= 1) return null;
  const from = (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, total);
  return (
    <div className="mt-6 flex flex-wrap items-center justify-between gap-3" data-testid="tagws-pagination">
      <span className="text-xs text-muted-foreground" data-testid="tagws-pagination-range">Showing {from}–{to} of {total}</span>
      <div className="flex items-center gap-2">
        <button className={BTN} disabled={page <= 1} onClick={() => onPage(page - 1)} data-testid="tagws-pagination-prev"><ChevronLeft size={14} /> Prev</button>
        <span className="font-mono text-xs text-muted-foreground" data-testid="tagws-pagination-page">Page {page} / {pageCount}</span>
        <button className={BTN} disabled={page >= pageCount} onClick={() => onPage(page + 1)} data-testid="tagws-pagination-next">Next <ChevronRight size={14} /></button>
      </div>
    </div>
  );
}
